import { render, staticRenderFns } from "./financialDetails.vue?vue&type=template&id=61350e7c&scoped=true&"
import script from "./financialDetails.vue?vue&type=script&lang=js&"
export * from "./financialDetails.vue?vue&type=script&lang=js&"
import style0 from "./financialDetails.vue?vue&type=style&index=0&id=61350e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61350e7c",
  null
  
)

export default component.exports